import getJSONFromFile from '@/util/fileUtility'

const SEPASettings = getJSONFromFile('SEPA.json')

export default SEPASettings
